export function omitUndefinedValues(obj) {
    return Object.fromEntries(
    //@ts-ignore
    Object.entries(obj).filter(([_key, value]) => value !== undefined));
}
